// Recovered compiled webpack factory 17989. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "ClientSegmentRoot", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(95155);
  function a(e) {
    let { Component: t, slots: a, params: o, promise: i } = e;
    {
      let { createRenderParamsFromClient: e } = r(307),
        i = e(o);
      return (0, n.jsx)(t, { ...a, params: i });
    }
  }
  (r(48302),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
